import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    recordStatus: 0,
    loadingStatus: 0,
    searchHistoryList: [], //收缩历史记录
    userInfo: null, //用户信息
    goodsInfo: null, //商品信息
    goodsInfoList: null, //商品信息列表
    addressList: [], // 省市区地址列表
    selectGoodsInfo: [], // 省市区地址列表
    selectCardId: [], // 选择的购物车商品Id
    shoppingAddress: {
      selectAddress: null,
      addressType: 'default',  // 默认地址
      defaultAddress: null
    }, //  收货地址
  },
  mutations: {
    updateRecordStatus(state, payload) {
      state.recordStatus = payload.recordStatus
    },
    updateSearchHistoryList(state, payload){
      state.searchHistoryList = payload.searchHistoryList
    },
    updateLoadingStatus(state, payload){
      state.loadingStatus = payload.loadingStatus
    },
    updateUserInfo(state, payload){
      state.userInfo = payload.userInfo
    },
    updateAddressList(state, payload){
      state.addressList = payload.addressList
    },
    updateShoppingAddress(state, payload){
      console.log(payload)
      if(payload.type === 'shoppingAddress'){
        state.shoppingAddress.selectAddress = payload.shoppingAddress
        state.shoppingAddress.addressType = 'select'
      }else if(payload.type === 'defaultAddress'){
        state.shoppingAddress.defaultAddress = payload.defaultAddress? payload.defaultAddress :state.shoppingAddress.defaultAddress
        state.shoppingAddress.addressType = 'default'
      }else if(payload.type === 'update'){
        state.shoppingAddress.defaultAddress = payload.defaultAddress
      }
    },
    updateSelectGoodsInfo(state, payload){
      state.selectGoodsInfo = payload.selectGoodsInfo
    },
    updateGoodsInfo(state, payload){
      state.goodsInfo = payload.goodsInfo
    },
    updateGoodsInfoList(state, payload){
      state.goodsInfoList = payload.goodsInfoList
    },
    updateSelectCardId(state, payload){
      state.selectCardId = payload.selectCardId
    },
  },
  plugins:[
    new VuexPersistence({
      reducer: state => ({
        userInfo: state.userInfo, //这个就是存入localStorage的值
        goodsInfo: state.goodsInfo, //这个就是存入localStorage的值
        selectCardId: state.selectCardId,
        goodsInfoList: state.goodsInfoList,
        searchHistoryList: state.searchHistoryList,
      }),
      storage: window.localStorage
    }).plugin
  ]
}) // 这里你可能已经有其他 module

export default store



// WEBPACK FOOTER //
// ./src/store/index.js